$(() => {
    $('#collapse-sabores').on('shown', function() {
        document.getElementById('collapse-sabores').scrollIntoView();
    });

    let collapseCategorias = $('.collapse-categorias');
    console.log(collapseCategorias);
    collapseCategorias.each((index, element) => {
        console.log();
        $(element).on('shown.bs.collapse', function(e) {
            console.log(e);
            let offsetTop = $(element).offset().top - 150;
            $(window).scrollTop(offsetTop);
        });
    });
});
